/**
 * configurator API
 * configurator API documentation
 *
 * OpenAPI spec version: 0.0.1
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */
/* tslint:disable:no-unused-variable member-ordering */

import {Inject, Injectable, Optional} from '@angular/core';
import { HttpClient, HttpEvent, HttpHeaders, HttpParams, HttpResponse } from '@angular/common/http';
import {CustomHttpUrlEncodingCodec} from '../encoder';

import {Observable} from 'rxjs';


import {BASE_PATH} from '../variables';
import {Configuration} from '../configuration';


@Injectable()
export class ConfiguratorScriptService {

    protected basePath = 'https://dmp.airiane.com/services/configurator';
    public defaultHeaders = new HttpHeaders();
    public configuration = new Configuration();

    constructor(protected httpClient: HttpClient, @Optional() @Inject(BASE_PATH) basePath: string, @Optional() configuration: Configuration) {
        if (basePath) {
            this.basePath = basePath;
        }
        if (configuration) {
            this.configuration = configuration;
            this.basePath = basePath || configuration.basePath || this.basePath;
        }
    }

    /**
     * @param consumes string[] mime-types
     * @return true: consumes contains 'multipart/form-data', false: otherwise
     */
    private canConsumeForm(consumes: string[]): boolean {
        const form = 'multipart/form-data';
        for (const consume of consumes) {
            if (form === consume) {
                return true;
            }
        }
        return false;
    }


    /**
     * Executer un script groovy par son chemin suivant le tenant et son affilié
     * Executer un script groovy par son chemin suivant le tenant et son affilié.&lt;br&gt;Exemple : mpl/Demo.groovy&lt;br&gt;Le paramètre &#39;X_DATASTORE_ID&#39; est le code qui correspond au tenant/datastore.&lt;br&gt;Le paramètre &#39;X_PARTNER_ID&#39; est le code qui correspond à l&#39;affilié.
     * @param xDataStoreID X-DataStoreID
     * @param path path
     * @param X_PARTNER_ID X-PARTNER-ID
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public runStoredScript2UsingGET(xDataStoreID: string, path: string, X_PARTNER_ID?: string, observe?: 'body', reportProgress?: boolean): Observable<any>;
    public runStoredScript2UsingGET(xDataStoreID: string, path: string, X_PARTNER_ID?: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<any>>;
    public runStoredScript2UsingGET(xDataStoreID: string, path: string, X_PARTNER_ID?: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<any>>;
    public runStoredScript2UsingGET(xDataStoreID: string, path: string, X_PARTNER_ID?: string, observe: any = 'body', reportProgress = false): Observable<any> {

        if (xDataStoreID === null || xDataStoreID === undefined) {
            throw new Error('Required parameter xDataStoreID was null or undefined when calling runStoredScript2UsingGET.');
        }

        if (path === null || path === undefined) {
            throw new Error('Required parameter path was null or undefined when calling runStoredScript2UsingGET.');
        }


        let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        if (path !== undefined && path !== null) {
            queryParameters = queryParameters.set('path', <any> path);
        }

        let headers = this.defaultHeaders;
        if (xDataStoreID !== undefined && xDataStoreID !== null) {
            headers = headers.set('X-DataStoreID', String(xDataStoreID));
        }
        if (X_PARTNER_ID !== undefined && X_PARTNER_ID !== null) {
            headers = headers.set('X-PARTNER-ID', String(X_PARTNER_ID));
        }

        // to determine the Accept header
        const httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.get<any>(`${this.basePath}/api/v1/script/store/run2`,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Executer un script groovy par son chemin
     * Executer un script groovy par son chemin relatif.&lt;br&gt;Exemple : mpl/Demo.groovy
     * @param path path
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public runStoredScriptUsingGET(path: string, observe?: 'body', reportProgress?: boolean): Observable<any>;
    public runStoredScriptUsingGET(path: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<any>>;
    public runStoredScriptUsingGET(path: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<any>>;
    public runStoredScriptUsingGET(path: string, observe: any = 'body', reportProgress = false ): Observable<any> {

        if (path === null || path === undefined) {
            throw new Error('Required parameter path was null or undefined when calling runStoredScriptUsingGET.');
        }

        let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        if (path !== undefined && path !== null) {
            queryParameters = queryParameters.set('path', <any>path);
        }

        let headers = this.defaultHeaders;

        // to determine the Accept header
        const httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.get<any>(`${this.basePath}/api/v1/script/store/run`,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

}
